import agent from './agent';
import config from '../config.json';
import ServiceBase from './ServiceBase';

const baseUrl = config.baseUrl;
const service = 'jernygateway';

// krakend - KDesk
// const baseUrl = 'http://localhost:8080';
// const service = 'datacollector';

class CmcService extends ServiceBase {
    /**
     * Get Cmc Fear and Greed indices of last 31 days
     * @returns {Promise}
     */
    getFearIndices = () => {
        const url = `${baseUrl}/${service}/cmc/fear`;
        const config = { headers: { Authorization: `Bearer ${this.getToken()}` } };

        return agent.get(url, config);
    };
}

const cmcService = new CmcService();
export default cmcService;
